import React, { useState, useEffect, useRef } from 'react';
import './inicio.css';
import { NavLink } from 'react-router-dom';

const Inicio = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const statsRef = useRef(null);

    const slides = [
        {
            text: "Protegiendo tu mundo digital",
            subtext: "Seguridad informática de última generación"
        },
        {
            text: "Detección de amenazas en tiempo real",
            subtext: "Monitoreo 24/7 de tu infraestructura"
        },
        {
            text: "Soluciones de ciberseguridad avanzada",
            subtext: "Mantén tu empresa protegida"
        }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prevSlide) => 
                prevSlide === slides.length - 1 ? 0 : prevSlide + 1
            );
        }, 5000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold: 0.2
            }
        );

        if (statsRef.current) {
            observer.observe(statsRef.current);
        }

        return () => {
            if (statsRef.current) {
                observer.unobserve(statsRef.current);
            }
        };
    }, []);

    return (
        <div className="inicio-container">
            {/* Carrusel */}
            <section className="hacker-carousel">
                <div className="carousel-container">
                    {slides.map((slide, index) => (
                        <div 
                            key={index} 
                            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                        >
                            <div className="glitch-text">
                                <h1 data-text={slide.text}>{slide.text}</h1>
                                <p className="subtext">{slide.subtext}</p>
                            </div>
                        </div>
                    ))}
                    <div className="carousel-indicators">
                        {slides.map((_, index) => (
                            <button
                                key={index}
                                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                                onClick={() => setCurrentSlide(index)}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* Sección Sobre Nosotros */}
            <section className="sobre-nosotros-section">
                <div className="container py-5">
                    <h2 className="text-center mb-4 text-glow">Sobre Nosotros</h2>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <p className="mb-4">
                                Nos dedicamos a brindar servicios de ciberseguridad de alta calidad a empresas de todos los 
                                tamaños. Nuestra misión es ayudar a nuestros clientes a proteger su información confidencial 
                                contra ataques cibernéticos.
                            </p>
                            <p className="mb-5">
                                Los expertos de TuEmpresa trabajan con todas las áreas de una organización, desde la alta dirección hasta el 
                                personal operativo. Ofrecen capacitación, asesoramiento y soluciones de seguridad personalizadas para ayudar a 
                                las organizaciones a proteger su información.
                            </p>
                        </div>
                    </div>

                    
                </div>
            </section>

            {/* Cards de Servicios y Soluciones */}
            <section className="servicios-section py-5">
                <div className="container">
                    <h2 className="text-center mb-5 text-glow">Nuestros Servicios</h2>
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="servicio-card card-glow">
                                <div className="card-content">
                                    <div className="icon-container">
                                        <i className="bi bi-diagram-3-fill"></i>
                                    </div>
                                    <h3 className="text-glow">GAP Análisis Framework</h3>
                                    <p>
                                        Evaluación exhaustiva de la seguridad basada en marcos 
                                        de referencia estándar de la industria.
                                    </p>
                                    <div className="card-features">
                                        <ul>
                                            <li><i className="bi bi-shield-lock-fill"></i> Framework NIST</li>
                                            <li><i className="bi bi-file-earmark-check-fill"></i> ISO27000</li>
                                            <li><i className="bi bi-list-check"></i> SANS Cis Controls</li>
                                        </ul>
                                    </div>
                                    <NavLink to="/servicios" className="btn btn-neon mt-3">
                                        <span className="btn-text">Ver Servicios</span>
                                        <i className="bi bi-arrow-right"></i>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="servicio-card card-glow">
                                <div className="card-content">
                                    <div className="icon-container">
                                        <i className="bi bi-bug"></i>
                                    </div>
                                    <h3 className="text-glow">Ethical Hacking</h3>
                                    <p>
                                        Servicios completos de pruebas de penetración 
                                        y evaluación de seguridad.
                                    </p>
                                    <div className="card-features">
                                        <ul>
                                            <li><i className="bi bi-globe"></i> Sitios WEB</li>
                                            <li><i className="bi bi-hdd-network"></i> Perímetro de Internet</li>
                                            <li><i className="bi bi-wifi"></i> Redes Inalámbricas</li>
                                        </ul>
                                    </div>
                                    <NavLink to="/servicios" className="btn btn-neon mt-3">
                                        <span className="btn-text">Ver Más</span>
                                        <i className="bi bi-arrow-right"></i>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sección Misión y Visión */}
            <section className="mision-vision-section py-5">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="vision-mision-card">
                                <div className="icon-container">
                                    <i className="bi bi-bullseye"></i>
                                </div>
                                <h3 className="text-glow">Misión</h3>
                                <p>
                                Es nuestra misión proteger los activos digitales de nuestros clientes.
                                Nos comprometemos a proporcionar soluciones de alta calidad y a trabajar
                                para anticipar, detectar y mitigar riesgos, proporcionando tranquilidad
                                y confianza a nuestros clientes.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vision-mision-card">
                                <div className="icon-container">
                                    <i className="bi bi-eye"></i>
                                </div>
                                <h3 className="text-glow">Visión</h3>
                                <p>
                                Es nuestra misión proteger los activos digitales de nuestros clientes.
                                Nos comprometemos a proporcionar soluciones de alta calidad y trabajar
                                para anticipar, detectar y mitigar riesgos, brindando tranquilidad
                                y confianza a nuestros clientes.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Inicio;